import type { ReactNode } from 'react';

interface PageHeaderProps { title: string; description?: string; actions?: ReactNode }

export default function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="page-head">
      <div className="ph-l">
        <h1>{title}</h1>
        {description && <div className="sub">{description}</div>}
      </div>
      {actions && <div style={{ display: 'flex', gap: '9px', flexWrap: 'wrap' }}>{actions}</div>}
    </div>
  );
}
